import { SUPPORT_EMAIL } from '../lib/lifecycle-notice.js';
import PageHeader from '../components/PageHeader.jsx';
import SectionCard from '../components/SectionCard.jsx';

/**
 * The existing "no access" page: a signed-in user with no usable scope.
 * IPC Global staff (an SSO sign-in) are told to ask for access in People,
 * where their sign-in already shows as an access request (ENTRAID-300);
 * everyone else keeps the Marketplace text.
 */
export default function NoAccess({ staff = false }) {
  return (
    <div className="max-w-2xl">
      <PageHeader title="Account not yet linked" />
      <SectionCard ariaLabel="Why you have no access yet" bodyClassName="space-y-2 text-ipc-muted">
        {staff ? (
          <>
            <p>
              Your IPC Global account is not assigned to a customer yet. Ask the customer admin or an onGuard operator to add you in People.
            </p>
            <p>An onGuard operator will see that you asked for access.</p>
          </>
        ) : (
          <p>
            We haven't found a customer record for your account yet. If you just
            completed an AWS Marketplace subscription, please follow the
            onboarding link from the post-subscribe page. Otherwise contact{' '}
            <a className="text-ipc-light underline" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
          </p>
        )}
      </SectionCard>
    </div>
  );
}
